import { createAsyncThunk } from '@reduxjs/toolkit';
import { getProjectAssignmentCosts } from '../services/getProjectAssignmentCosts';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';

// return only assignments not marked as deleted
export const loadAssignmentCostsForProject = createAsyncThunk(
  'assignments/loadAssignmentCostsForProject',
  async ({ fromDate, toDate }, { getState, dispatch }) => {
    const state = getState();
    const selectedProjectId = selectSelectedProjectId(state);
    const projectAssignments = await getProjectAssignmentCosts(
      selectedProjectId,
      fromDate,
      toDate
    );
    return projectAssignments;
  }
);
